import { useEffect, useMemo } from "react";

import { useRequest } from "../../../hooks/useRequest";
import routes from "../../../routes";
import { parseProspectPrestoneId } from "../parser";

function useProspectPrestoneId(prospectId: string | undefined) {
  const { fetch, response, error } = useRequest();

  useEffect(() => {
    if (!prospectId) {
      return;
    }

    const params = new URLSearchParams({ prospectId, limit: "1" });
    fetch("GET", `${routes.api.prestoneProjects.base({})}?${params}`);
  }, [fetch, prospectId]);

  return useMemo(() => {
    if (!response?.data || error) {
      return null;
    }

    try {
      return parseProspectPrestoneId(response.data);
    } catch {
      return null;
    }
  }, [response, error]);
}

export default useProspectPrestoneId;
